import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import bedImg from "../../Assets/Logos/beds.png";
import ConfigureRoom from "../../components/AdminSideComponents/ConfigureRoom";
import toast from "react-hot-toast";
import SeeRoomDetails from "../../components/AdminSideComponents/SeeRoomDetails";
const RoomsPage = () => {
  const { id } = useParams(); // building ID
  const [building, setBuildings] = useState({});
  const [loadConfig, setLoadConfig] = useState(false);
  const [selectedRoomData, setSelectedRoomData] = useState(null);
  const [roomsByBuilding, setRoomsByBuilding] = useState([]);
  const [loadRoomDetails, setLoadRoomDetails] = useState(false);
  const [currentRoomDetails, setCurrentRoomDetails] = useState({});

  // Function to get building details by ID
  const getBuildingsById = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/resources/get_building_by_id/${id}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response.data.data);
        setBuildings(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Function to get rooms by building ID
  const getRoomsByBuilding = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/rooms/get_rooms_by_buildingId/${id}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response.data.data);
        setRoomsByBuilding(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Call API to fetch building data on component mount
  useEffect(() => {
    getBuildingsById();
    getRoomsByBuilding();
  }, [loadConfig, loadRoomDetails]);

  // Function to handle room click
  const onRoomClick = (floorNumber, roomNumber) => {
    const roomData = {
      floorNumber,
      roomNumber,
      buildingId: id, // use the building ID from useParams
    };
    setSelectedRoomData(roomData);
    setLoadConfig(true);
  };

  //Function to handle room details modal open
  console.log(currentRoomDetails);
  const findRoom = (floorNumber, roomNumber) => {
    const room = roomsByBuilding.find((room) => {
      return room.floorNumber === floorNumber && room.roomNumber === roomNumber;
    });
    setCurrentRoomDetails(room);
    setLoadRoomDetails(true);
  };

  // Helper function to check if a room exists in roomsByBuilding
  const isRoomOccupied = (floorNumber, roomNumber) => {
    return roomsByBuilding.some(
      (room) =>
        room.floorNumber === floorNumber && room.roomNumber === roomNumber
    );
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      {/* Conditionally render ConfigureRoom with selected room data */}
      {loadConfig && (
        <ConfigureRoom
          setLoadConfig={setLoadConfig}
          roomData={selectedRoomData}
        />
      )}
      {loadRoomDetails && (
        <SeeRoomDetails
          setLoadRoomDetails={setLoadRoomDetails}
          currentRoomDetails={currentRoomDetails}
        />
      )}

      <div className="bg-gray-50 p-4 rounded-lg shadow-lg w-full">
        {/* Header */}
        <div className="flex justify-between items-center p-4 bg-gray-100 rounded-t-lg">
          <h2 className="text-lg font-semibold text-gray-800">
            {building?.nameBuilding}
          </h2>
          <span className="text-lg font-semibold text-gray-700">
            {building?.totalRooms} Rooms
          </span>
        </div>

        {/* Floors */}
        <div className="p-4 space-y-8">
          {building?.floorDetails?.map((floor, index) => (
            <div key={index}>
              {/* Floor Title */}
              <h3 className="text-gray-700 font-semibold mb-4">
                Floor {floor.floorNumber}
              </h3>

              {/* Rooms */}
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 gap-4">
                {Array.from({ length: floor.numberOfRooms }, (_, idx) => {
                  const roomNumber = idx + 1;
                  const isOccupied = isRoomOccupied(
                    floor.floorNumber,
                    roomNumber
                  );
                  return (
                    <div
                      key={idx}
                      onClick={() => {
                        if (isOccupied) {
                          findRoom(floor.floorNumber, roomNumber);
                        } else {
                          onRoomClick(floor.floorNumber, roomNumber);
                        }
                      }}
                      className={`cursor-pointer p-2 rounded-md flex flex-col items-center ${
                        isOccupied
                          ? "bg-green-200 border border-green-600"
                          : "bg-blue-50 border border-blue-100"
                      }`}
                    >
                      <img
                        src={bedImg}
                        alt="No Image"
                        className="w-[1.7rem] my-4"
                      />
                      <span className="text-sm text-gray-700 font-semibold">
                        R-F{floor.floorNumber}
                        {String(roomNumber).padStart(3, "0")}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RoomsPage;
